<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>User Roles</v-toolbar-title>
                <v-divider color="white" class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-row dense>
                <div class="pa-2 mt-2 d-inline-block" v-for="(item, j) in emp_roles" :key="j">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-card :elevation="2" color="brand white--text"
                                class="back-hover d-flex align-center justify-center text-center"
                                style="border-radius: 16px; height: 50px; width: 140px; cursor: pointer;"
                                @click="openlink(item)" v-bind="attrs" v-on="on">
                                <strong class="text-truncate" style="
                                    font-size: 14px;
                                    padding: 0 10px;
                                    max-width: 140px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    display: block;
                                ">
                                    {{ item.name }}
                                </strong>
                            </v-card>
                        </template>
                        <span>{{ item.name }}</span>
                    </v-tooltip>
                </div>

            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
// import epsHeader from "../shared/UpdatedHeader";
export default {
    data: () => ({
        snackbar_msg: "",
        color: "",
        snackbar: false,
        emp_roles: [],
        items: [],

    }),
    // components: {
    //     epsHeader: epsHeader,
    // },
    methods: {
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getInitials(name) {
            // Split the name into words, get the first letter of each word, and join them
            return name
                .split(" ")
                .map((word) => word[0].toUpperCase())
                .join("");
        },
        back() {
            this.$router.push("/home-updated");
        },
        openlink(child) {
            sessionStorage.removeItem("para_role");
            sessionStorage.removeItem("para_role_type");
            sessionStorage.removeItem("role_dashboard_path");
            sessionStorage.setItem("para_role", child.para_role);
            sessionStorage.setItem("para_role_type", child.para_role_type);

            if (child.direct_link != null) {
                this.$router.push({ name: child.direct_link });
                return;
            }

            this.$router.push({
                name: child.link,
                params: {
                    role_type: child.para_role_type,
                    role_name: child.para_role,
                },
            });  
        },
        // openlink(child) {
        //     localStorage.setItem("para_role", child.para_role);
        //     localStorage.setItem("para_role_type", child.para_role_type);
        //     if (child.direct_link != null) {
        //         this.$router.push({ name: child.direct_link });
        //         return;
        //     }

        //     this.$router.push({
        //         name: child.link,
        //         params: {
        //             role_type: child.para_role_type,
        //             role_name: child.para_role,
        //         },
        //     });
        // },
    },

    mounted() {
        this.emp_roles = JSON.parse(sessionStorage.getItem("emp_role")) || [];
        if (!sessionStorage.getItem("emp_role_dashboard_path")) {
        sessionStorage.setItem("emp_role_dashboard_path", "/emp-role-dashboard");
        }
        this.items = [
            { text: "Home", disabled: false, href: "/home-updated" },
            { text: this.emp_roles.name, disabled: true, href: "" }  // Now local_role_name is defined
        ];
    },
};
</script>
<style scoped>
.circle2 {
    margin: auto;
    width: 60px;
    height: 60px;
    margin-top: 15px;
    margin-bottom: 15px;
    /* padding-top: 10px; */
    background: white;
    border-radius: 50%;
}

.breadcrumb {

    padding: 10px;

    margin-left: 100px;
    margin-top: -57px;
    font-size: medium;
    font-weight: bold;
}
</style>